<template>
  <v-card>
    <v-card-title>
      <h4>{{ title }}</h4>
    </v-card-title>
    <v-card-text>
      {{ infoText }}
      <v-form ref="form" :lazy-validation="true">
        <v-row cols="12">
          <v-col>
            <v-radio-group v-model="radioGroup" @change="changeSelection">
              <v-radio label="Nej tack, bara ändra." :value="1"></v-radio>
              <v-radio label="Meddela med standardtext." :value="2"></v-radio>
              <v-radio label="Skriv ett eget meddelande" :value="3"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col>
            <v-textarea
              outlined
              :disabled="radioGroup!==3"
              label="Meddelande"
              v-model="message"
              :rules="[rules.requiredIf(radioGroup>1,message)]"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn outlined @click="close">
        <v-icon>$sl-cancel</v-icon>Avbryt
      </v-btn>
      <v-btn @click="send" data-cy="accept-new-state-change">
        <v-icon>$sl-check</v-icon>Fortsätt
      </v-btn>      
    </v-card-actions>
  </v-card>
</template>

<script>
import { RulesMixin } from '@/components/mixins'

// @group Application
// ApplicationMessage component
export default {
  name: 'ApplicationMessage',

  mixins: [
    RulesMixin
  ],

  props: {
    //has title
    title: {
      // `String` 
      type: String,
      // The default value is: `Skicka meddelande?`
      default: 'Skicka meddelande?'
    },
    //has info text
    infoText: {
      // `String` 
      type: String,
      // The default value is: `Vill du meddela inblandade parter?`
      default: 'Vill du meddela inblandade parter?'
    },
    //has default message
    defaultMessage: {
       // `String` 
      type: String,
      // The default value is: `Hej`
      default: 'Hej'
    },
  },

  data: () => ({
    radioGroup: 1,
    message: ''
  }),

  created () {
    this.message = this.defaultMessage
  },

  methods: {
    close () {
      this.$emit('close')
    },

    send () {
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
        return
      }
      // Fire send event,if form is valid and submited
      // @arg The argument is a object representing sendMessage and message itself
      this.$emit('send', {
        sendMessage: this.radioGroup > 1,
        message: this.radioGroup > 1 ? this.message : null
      })
    },

    changeSelection() {
      if (this.radioGroup === 2) {
        this.message = this.defaultMessage
      }
      this.$refs.form.resetValidation()
      this.$refs.form.validate()
    }

  }
}
</script>

<style>
</style>